// src/Components/FeatureSection1.js
import Badge from "./Badge";
import { PaintBrushIcon, ComputerDesktopIcon, CameraIcon, PencilIcon } from '@heroicons/react/24/outline';

const physiotherapyFeatures = [
    {
        name: 'Pain Management',
        description:
            'Harnessing evidence-based techniques to alleviate chronic and acute pain, ensuring you can reclaim your quality of life without persistent discomfort.',
    },
    {
        name: 'Post-Surgical Rehabilitation',
        description:
            'Tailored programs to accelerate recovery post-surgery, restoring strength, flexibility, and function to the affected areas.',
    },
    {
        name: 'Sports Injury Treatment',
        description:
            "Whether it's overuse, strain, or acute trauma, we offer targeted treatments to get athletes back to their optimal performance levels safely.",
    },
    {
        name: 'Manual Therapy',
        description:
            'Hands-on techniques aimed at reducing pain, improving mobility, and facilitating natural healing by targeting specific areas of the body.',
    },
    {
        name: 'Geriatric Physiotherapy',
        description:
            'Specialized care designed to address the unique challenges faced by older adults, such as arthritis, osteoporosis, and balance disorders.',
    },
    {
        name: 'Home-based Exercises',
        description:
            "Empower your recovery journey even at home. With personalized exercises and guidelines, ensure you're progressing safely and effectively outside the clinic.",
    }
];

const designFeatures = [
    {
        name: 'Brand Identity Design',
        description:
            'Creating cohesive visual identities that tell your brand story. From logos to color palettes, we craft memorable brand experiences.',
        icon: PaintBrushIcon,
    },
    {
        name: 'Digital & Web Design',
        description:
            'Modern, responsive web designs that captivate and convert. UI/UX focused solutions for optimal user experiences.',
        icon: ComputerDesktopIcon,
    },
    {
        name: 'Print & Marketing Materials',
        description:
            'Eye-catching brochures, business cards, posters, and promotional materials that make your message stand out.',
        icon: PencilIcon,
    },
    {
        name: 'Social Media Graphics',
        description:
            'Engaging visual content optimized for all social platforms. Build your online presence with stunning graphics.',
        icon: CameraIcon,
    },
];

export default function FS1() {
    return (
        <div className="bg-gradient-to-b from-white to-gray-50 py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                {/* Physiotherapy Services */}
                <div className="mx-auto max-w-2xl lg:mx-0">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Comprehensive Physiotherapy Care</h2>
                    <p className="mt-6 text-lg leading-8 text-gray-600">
                        Offering a holistic approach to physical well-being, our range of services is designed to cater to your unique needs, ensuring optimal recovery and wellness.
                    </p>
                </div>
                <dl className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 text-base leading-7 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                    {physiotherapyFeatures.map((feature) => (
                        <div key={feature.name} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
                            <Badge title='Book Now' href='/' />
                            <dt className="font-semibold text-gray-900 mt-4">{feature.name}</dt>
                            <dd className="mt-2 text-gray-600">{feature.description}</dd>
                        </div>
                    ))}
                </dl>

                {/* Graphic Design Services */}
                <div className="mx-auto max-w-2xl lg:mx-0 mt-24">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Creative Design Solutions</h2>
                    <p className="mt-6 text-lg leading-8 text-gray-600">
                        Transform your vision into stunning visual experiences. Our design services blend creativity with strategy to deliver impactful results.
                    </p>
                </div>
                <dl className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 text-base leading-7 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    {designFeatures.map((feature) => (
                        <div key={feature.name} className="relative bg-gradient-to-br from-indigo-50 to-purple-50 rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
                            <div className="flex items-start space-x-4">
                                <div className="flex-shrink-0">
                                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-indigo-600">
                                        <feature.icon className="h-6 w-6 text-white" aria-hidden="true" />
                                    </div>
                                </div>
                                <div>
                                    <Badge title='View Portfolio' href='/portfolio' />
                                    <dt className="font-semibold text-gray-900 mt-4">{feature.name}</dt>
                                    <dd className="mt-2 text-gray-600">{feature.description}</dd>
                                </div>
                            </div>
                        </div>
                    ))}
                </dl>
            </div>
        </div>
    )
}